module.exports = __webpack_public_path__ + "static/media/avatar.8bc5fea2.png";